const STORAGE_KEY = "echoGuestPostQuota";

function todayKey() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export function readGuestPostQuota() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return { guestId: null, usedOn: null };

        const parsed = JSON.parse(raw);
        return {
            guestId: parsed?.guestId ?? parsed?.guest_id ?? null,
            usedOn: parsed?.usedOn ?? parsed?.used_on ?? null,
        };
    } catch {
        return { guestId: null, usedOn: null };
    }
}

export function writeGuestPostQuota({ guestId, usedOn = todayKey() }) {
    const next = {
        guestId: guestId ?? null,
        usedOn: usedOn ?? todayKey(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
}

export function hasUsedGuestPostsToday(quota = readGuestPostQuota()) {
    return Boolean(quota?.guestId && quota?.usedOn === todayKey());
}

export function getGuestPostQuotaTodayKey() {
    return todayKey();
}

export const GUEST_POST_QUOTA_STORAGE_KEY = STORAGE_KEY;
